module.exports = __webpack_public_path__ + "static/img/vladan-jocic.618f3e72.jpg";